module.exports = __webpack_public_path__ + "static/media/image1.77135d14.jpg";